// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.prompt[data-v-431cd096] {\n  text-align: center;\n  font-size: 18px;\n}\n.color87[data-v-431cd096] {\n  color: #898787;\n  font-size: 14px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
